import { ChangeDetectionStrategy, Component } from '@angular/core';
import { keys, matches } from '@sama/micro-dash';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-input-summary',
  templateUrl: './input-summary.component.html',
  styleUrls: ['./input-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputSummaryComponent {
  inputData$ = this.store('task')('data').$.pipe(
    map((names) => keys(names).map((name) => ({ name, isPopoverOpen: false }))),
  );

  constructor(private store: TaskWorkspaceStore) {}

  inputFormat(inputName: string) {
    const input = this.store
      .state()
      .project.inputs.find(matches({ name: inputName }));
    return input && input.format;
  }

  getValue(inputName: string) {
    return this.store.state().task.data[inputName];
  }

  getUrl(inputName: string) {
    const url = this.store.getInputUrl(inputName);
    if (!!url && !url.includes('.bin')) {
      return url;
    }
    return '';
  }
}
